module.exports = "<style>\n\tdiv .google-visualization-tooltip>ul>li>span {\n\t\twhite-space: nowrap\n\t}\n</style>\n<div id=\"commonchart\" flex layout=\"row\" layout-align=\"start center\" layout-wrap style=\"overflow-x:auto\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/common-chart/views/commonChart.html
// module id = 1361
// module chunks = 438